import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bdc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const euros = (cents) => `${((cents || 0) / 100).toFixed((cents % 100) ? 2 : 0)}€`;
